/**
 * Created by Deloitte Digital on 3/10/2017.
 */

import CommonApp from '../../app.js';

CommonApp.module.filter('nsSsnCheck', function() {
    return function(value) {
        if (value) {
            if (value.length >= 9) {
                return value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5);
            } else if (value.length >= 5) {
                return value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5);
            } else if (value.length >= 3) {
                return value.substr(0, 3) + '-' + value.substr(3);
            }
        }
        return value;
    };
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/filters/ssnCheck/ssnCheckFilter.js
// module id = 274
// module chunks = 0